/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Notes_SavedInputs */

const en_task_notes_saved = /** @type {(inputs: Task_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const pt_br2_task_notes_saved = /** @type {(inputs: Task_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvo`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Task_Notes_SavedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_notes_saved = /** @type {((inputs?: Task_Notes_SavedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Notes_SavedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_notes_saved(inputs)
	return pt_br2_task_notes_saved(inputs)
});